// Copyright (c) 2016 Deere & Company

import {findMatchingKey, validAmountOfUse} from '../../../shared/services/claim-shared-helper';
import actions from '../../../action-list';
import {getDefaultState as getKeyValuePairDefaultState} from '@deere/cps-it.warranty-model-factory/lib/key-value-pair';
import {mapFormValidation} from '../services/claim-validation-helper';

export const updateResponsibleAccount = (accountId, dealers) => ({
    accountId,
    dealers,
    type: actions.UPDATE_CLAIM_MAINTENANCE_PLAN_RESPONSIBLE_ACCOUNT
});

export const updateFormValidation = (property, value) => ({
    property,
    type: actions.UPDATE_CLAIM_MAINTENANCE_PLAN_FORM_VALIDATION,
    validity: mapFormValidation(property, value)
});

export const updateWorkOrderOne = workOrderOne => ({
    type: actions.UPDATE_CLAIM_MAINTENANCE_PLAN_WORK_ORDER_ONE,
    workOrderOne
});

export const updateWorkOrderTwo = workOrderTwo => ({
    type: actions.UPDATE_CLAIM_MAINTENANCE_PLAN_WORK_ORDER_TWO,
    workOrderTwo
});

export const updateRepairNumber = repairNumber => ({
    repairNumber,
    type: actions.UPDATE_CLAIM_MAINTENANCE_PLAN_REPAIR_NUMBER
});

export const updateServiceDate = date => ({
    date,
    type: actions.UPDATE_CLAIM_MAINTENANCE_PLAN_SERVICE_DATE
});

export const updateUseAmount = amount => ({
    amount: validAmountOfUse(amount),
    type: actions.UPDATE_CLAIM_MAINTENANCE_PLAN_USE_AMOUNT
});

export const updateUseAmountUnit = (key, allowedUnits) => ({
    allowedUnits,
    key,
    type: actions.UPDATE_CLAIM_MAINTENANCE_PLAN_USE_AMOUNT_UNIT
});

export const updatePlanName = (planName, plans) =>

    dispatch => {

        dispatch({
            planName,
            plans,
            type: actions.UPDATE_CLAIM_MAINTENANCE_PLAN_SELECTED_OPEN_MAINTENANCE_PLAN
        });

        dispatch({
            data: getKeyValuePairDefaultState(),
            type: actions.RESET_CLAIM_MAINTENANCE_PLAN_MACHINE_TYPE
        });

        dispatch({
            data: false,
            type: actions.RESET_CLAIM_MAINTENANCE_PLAN_NO_TRAVEL
        });

        dispatch({
            data: getKeyValuePairDefaultState(),
            type: actions.RESET_CLAIM_MAINTENANCE_PLAN_SERVICE_INTERVAL
        });

        dispatch({
            comments: '',
            type: actions.RESET_CLAIM_MAINTENANCE_PLAN_COMMENTS
        });

        dispatch({
            additionalComments: '',
            type: actions.RESET_CLAIM_MAINTENANCE_PLAN_ADDITIONAL_COMMENTS
        });

        dispatch({
            property: 'serviceInterval',
            type: actions.UPDATE_CLAIM_MAINTENANCE_PLAN_FORM_VALIDATION,
            validity: true
        });

        dispatch({
            property: 'comments',
            type: actions.UPDATE_CLAIM_MAINTENANCE_PLAN_FORM_VALIDATION,
            validity: true
        });

    };

export const updateServiceInterval = (serviceInterval, serviceIntervals) => ({
    data: findMatchingKey(serviceInterval, serviceIntervals),
    type: actions.UPDATE_CLAIM_MAINTENANCE_PLAN_SERVICE_INTERVAL
});

export const updateMachineType = (machineType, machineTypes) => ({
    data: findMatchingKey(machineType, machineTypes),
    type: actions.UPDATE_CLAIM_MAINTENANCE_PLAN_MACHINE_TYPE
});

export const updateNoTravel = noTravel => ({
    data: noTravel,
    type: actions.UPDATE_CLAIM_MAINTENANCE_PLAN_NO_TRAVEL
});

export const updateComments = comments => ({
    comments,
    type: actions.UPDATE_CLAIM_MAINTENANCE_PLAN_COMMENTS
});

export const updateAdditionalComments = additionalComments => ({
    additionalComments,
    type: actions.UPDATE_CLAIM_MAINTENANCE_PLAN_ADDITIONAL_COMMENTS
});

export const updateStickyHeaderVisibility = status =>

    dispatch => {

        const STICKY_STATUS_FIXED = 2;

        dispatch({
            isVisible: status === STICKY_STATUS_FIXED,
            type: actions.UPDATE_CLAIM_MAINTENANCE_PLAN_STICKY_HEADER_VISIBILITY
        });

    };

export const resetClaim = () => ({
    type: actions.RESET_CLAIM_MAINTENANCE_PLAN
});



// WEBPACK FOOTER //
// ./src/claim/marketing/maintenance-plan/action-creators/claim-details.js